import React from "react";
import { FiShoppingCart } from "react-icons/fi";
import { formatMoneyByLanguage } from "../../helpers/money";

const MAIN_COLOR = "rgb(29, 71, 127)";

const ProductCard = ({
  product,
  quantity = 0,
  onChangeQuantity,
  language = "tr",
}) => {
  const unitPrice = Number(product?.unitPrice ?? 0);

  const langKey = String(language || "tr")
    .toLowerCase()
    .replace("_", "-")
    .trim()
    .slice(0, 2);

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-xl border border-slate-300 bg-white shadow-sm transition duration-200 hover:-translate-y-[1px] hover:shadow-md">
      <div className="flex h-[120px] items-center justify-center bg-[#efefef] p-3 sm:h-[135px] lg:h-[145px]">
        {product?.image ? (
          <img
            src={product.image}
            alt={product?.name || ""}
            className="max-h-[78px] max-w-[78px] object-contain sm:max-h-[88px] sm:max-w-[88px] lg:max-h-[95px] lg:max-w-[95px]"
          />
        ) : (
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm" />
        )}
      </div>

      <div className="px-3 pt-3 pb-2 text-[13px] leading-5 text-slate-800 sm:text-[14px]">
        <div className="line-clamp-2 min-h-[40px] sm:min-h-[44px]">
          {product?.name || ""}
        </div>
      </div>

      <div
        className="mt-auto px-3 py-2 text-white"
        style={{ backgroundColor: MAIN_COLOR }}
      >
        <div className="text-right text-[13px] font-bold">
          {formatMoneyByLanguage(unitPrice, langKey)}
        </div>
      </div>

      <div className="px-2 py-2" style={{ backgroundColor: MAIN_COLOR }}>
        <div className="flex h-9 w-full overflow-hidden rounded-md border border-white/20 bg-white/10 text-white">
          <button
            type="button"
            onClick={() => onChangeQuantity(product, "decrease")}
            className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
          >
            -
          </button>

          <div className="flex flex-1 items-center justify-center border-x border-white/20">
            {quantity > 0 ? (
              <span className="text-sm font-semibold">{quantity}</span>
            ) : (
              <FiShoppingCart size={15} />
            )}
          </div>

          <button
            type="button"
            onClick={() => onChangeQuantity(product, "increase")}
            className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;